import styled from '@emotion/styled';

export const TradingEventsContent = styled('div', { label: 'TradingEventsContent' })`
    display: flex;
    flex-flow: column nowrap;
    @media screen and (min-width: 1120px) {
        flex-direction: row;
    }
`;

export const TradingEventsListWrapper = styled('div', { label: 'TradingEventsListWrapper' })`
    @media screen and (min-width: 1120px) {
        flex: 0 0 66%;
        width: 66%;
    }
`;

export const TradingEventsOtherWrapper = styled('div', { label: 'TradingEventsOtherWrapper' })`
    @media screen and (min-width: 1120px) {
        flex: 0 0 34%;
        max-width: 34%;
        padding-left: 10px;
    }
`;
